import React from 'react'
import ComingSoon from '../../components/comingSoon/ComingSoonPage'

const SettingsPage = () => {
  return (
<>
<ComingSoon/>
</>
  )
}

export default SettingsPage